import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography, Grid } from '@mui/material';
import { dashboardContext } from './DashboardContext';
import Moment from 'react-moment';
import Content from './Content';

let ProductsInventoryDashboard = () => {

    let { productInventories } = useContext(dashboardContext);

    return (
        <Content title='Last updated inventories'>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>SKU</TableCell>
                        <TableCell>B2B</TableCell>
                        <TableCell>B2C</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {productInventories.map((inventory, index) =>
                        <TableRow hover key={index} sx={{ height: 60, maxHeigh: 60 }}>
                            <TableCell>{inventory.sku}</TableCell>
                            <TableCell>
                                <>
                                    Quantity: {inventory.b2BInfo.quantity}<br />
                                    <Typography variant="caption">Updated on <Moment date={inventory.b2BInfo.lastUpdatedOn} format="LLL" /></Typography>
                                </>
                            </TableCell>
                            <TableCell>
                                <>
                                    Quantity: {inventory.b2CInfo.quantity}<br />
                                    <Typography variant="caption">Updated on <Moment date={inventory.b2CInfo.lastUpdatedOn} format="LLL" /></Typography>
                                </>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {productInventories.length === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={3}>
                                <Typography variant="subtitle2">No inventories found</Typography>
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
        </Content>
    )
}

export default ProductsInventoryDashboard;